import script from "./NewsPageThemesList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageThemesList.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageThemesList.vue?vue&type=style&index=0&id=47a28fa0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a28fa0"]])

export default __exports__